import axios from 'axios';
import { API_URL } from '../../api/api';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const base = `${API_URL}/api/dashboard-layout`;

export async function getLayout(kind) {
  const res = await axios.get(`${base}/${kind}`, { headers: authHeaders() });
  return res.data; // { layout, hidden, prefs, updated_at }
}

export async function putLayout(kind, { layout, hidden, prefs }) {
  const res = await axios.put(
    `${base}/${kind}`,
    { layout, hidden, prefs },
    { headers: { ...authHeaders(), 'Content-Type': 'application/json' } }
  );
  return res.data;
}

export async function deleteLayout(kind) {
  const res = await axios.delete(`${base}/${kind}`, {
    headers: authHeaders(),
  });
  return res.data;
}
